import { KCFColor } from 'styles/themes/KCFColor';
import type { KCFTheme } from 'styles/themes/KCFTheme';
import { LightTheme } from 'styles/themes/light';

export const DarkTheme: KCFTheme = {
    bodyBackgroundColor: KCFColor.darkGrey9,
    backgroundColor: KCFColor.darkGrey8,
    backgroundColorActive: KCFColor.darkGrey7,
    shadeBackgroundColor: KCFColor.mediumGrey7,
    secondaryBackgroundColor: KCFColor.darkGrey8,

    borderColor: KCFColor.darkGrey7,
    navColor: KCFColor.darkGrey8,
    navBorderColor: KCFColor.mediumGrey6,
    primaryText: KCFColor.lightGrey1,
    secondaryText: KCFColor.mediumGrey4,
    secondaryButton: KCFColor.darkGrey7,
    secondaryButtonHover: KCFColor.mediumGrey6,
    // TODO: this is translated; may not be correct
    cancelButton: KCFColor.darkGrey7,
    // TODO: this is translated; may not be correct
    cancelButtonHover: KCFColor.mediumGrey6,
    // TODO: This color was not picked by a designer.
    disabledText: KCFColor.mediumGrey5,
    link: KCFColor.linkShiftedDefault,
    linkShifted: KCFColor.linkDefault,
    title: KCFColor.white,

    // Form elements
    inputBorder: KCFColor.mediumGrey5,
    filterRadioButton: KCFColor.mediumGrey6,

    infoBox: KCFColor.darkGrey8,

    chartBackgroundColor: KCFColor.darkGrey8,
    chartPlotGridBackgroundColor: KCFColor.darkGrey7,

    // timeseries
    timeseriesBackgroundColor: KCFColor.black,
    timeseriesAxisColor: KCFColor.timeseriesAxisReverse,
    timeseriesGridColor: KCFColor.timeseriesGridReverse,
    timeseriesDrawerUnselectedColor: KCFColor.darkGrey8,
    // TODO: This color was not picked by a designer.
    timeseriesErrorBackgroundColor: KCFColor.orange6,
    activityLineColor: KCFColor.darkGrey7,
    markerTableSelectedColor: KCFColor.mediumGrey7,

    iconButtonBackgroundHover: KCFColor.mediumGrey6,

    tabSelected: KCFColor.darkGrey7,

    successToastColor: KCFColor.darkGreen,
    errorToastColor: KCFColor.darkRed,

    issueQueueButtonBackgroundColor: KCFColor.mediumGrey6,

    kcfOnlyLozengeBackground: KCFColor.lightGrey4,
    kcfOnlyLozengeText: KCFColor.black,

    // Sentry validation indicator
    sentryValidatedIconColor: KCFColor.green3,

    // --- MISSING COLORS ---
    activeBackgroundColor1: LightTheme.activeBackgroundColor1,
    activeBackgroundColor2: LightTheme.activeBackgroundColor2,
    primaryBoxShadow: LightTheme.primaryBoxShadow,
    modalBoxShadow: LightTheme.modalBoxShadow,
    menuBoxShadow: LightTheme.menuBoxShadow,
    deleteButton: LightTheme.deleteButton,
    deleteButtonHover: LightTheme.deleteButtonHover,
    warningButton: LightTheme.warningButton,
    warningButtonHover: LightTheme.warningButtonHover,
    inputBorderFocused: LightTheme.inputBorderFocused,
    inputBorderInvalid: LightTheme.inputBorderInvalid,
    inputBorderValid: LightTheme.inputBorderValid,
    assetCardReportBackgroundColor: LightTheme.assetCardReportBackgroundColor,
    workbenchHeader: LightTheme.workbenchHeader,
    workbenchHeaderButtonHover: LightTheme.workbenchHeaderButtonHover,
    treeviewIconColor: LightTheme.treeviewIconColor,
    notificationsCog: LightTheme.notificationsCog,
    notificationsHeaderText: LightTheme.notificationsHeaderText,
    tabsBottomBorder: LightTheme.tabsBottomBorder,
    popupText: LightTheme.popupText,
    popupBackgroundColor: LightTheme.popupBackgroundColor,
    iconColor: LightTheme.iconColor,
    hardwareStatusActionButtonBackground: LightTheme.hardwareStatusActionButtonBackground,
    hardwareStatusActionButtonBackgroundHover:
        LightTheme.hardwareStatusActionButtonBackgroundHover,
    criticalSeverity: LightTheme.criticalSeverity,
    alarmSeverity: LightTheme.alarmSeverity,
    warningSeverity: LightTheme.warningSeverity,
    timeseriesErrorIconColor: LightTheme.timeseriesErrorIconColor,

    // Dashboards
    dashboardAccentPrimary: KCFColor.blue5,
    dashboardAxisText: KCFColor.dashboardAxisTextLighter,
};
